import { useEffect } from "react";

const SCROLL_LOCK_ATTR = "data-scroll-locked";

function clearScrollLock() {
  if (document.body.getAttribute(SCROLL_LOCK_ATTR) === "1") {
    document.body.removeAttribute(SCROLL_LOCK_ATTR);
  }
}

export function useBodyScrollUnlock() {
  useEffect(() => {
    clearScrollLock();

    const observer = new MutationObserver(() => {
      clearScrollLock();
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: [SCROLL_LOCK_ATTR],
    });

    return () => observer.disconnect();
  }, []);
}
